export const getFormattedNow = (): string => {
  const now = new Date();
  return (
    now.getFullYear() +
    '/' +
    String(now.getMonth() + 1).padStart(2, '0') +
    '/' +
    String(now.getDate()).padStart(2, '0') +
    ' ' +
    String(now.getHours()).padStart(2, '0') +
    ':' +
    String(now.getMinutes()).padStart(2, '0') +
    ':' +
    String(now.getSeconds()).padStart(2, '0')
  );
};

export const handleUpdateTimestamp = (
  storageKey: string,
  callback: (formattedDate: string) => void
) => {
  const formattedDate = getFormattedNow();
  callback(formattedDate);
  try {
    localStorage.setItem(storageKey, formattedDate);
  } catch (error) {
    console.error('Failed to write to localStorage:', error);
  }
};
